import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import formControl from "globals/form-control";
import { nmsMenus } from "globals/configuration/nms";
import { adminMenus } from "globals/configuration/admin";
import { Box } from "@mui/material";
const Attributes = {
  formSize: "md",
  columns: 3,
  enableRefresh: true,
  enableAddButton: false,
  enableAdvanceSearch: true,
  enableGroupHeading: false,
  verticalTabs: false,
  tabSize: 4,
  enableMultipleUpdate: false,
  dynamicTitle: false,
  multiUpdateTitle: "Approve Selected",
  enableMultipleDeleteButton: false,
  changeButtonIcon:false,
  iconName:"not_interested",
  ButtonNames:"Reject Selected",
  modes: adminMenus.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
  settingsMode: false,
};

const operationURLS = {
  list: "/commandApproval/list",
  update: "/commandApproval/approve",
  register: "/discoverSubnet/create ",
  delete: "/commandApproval/reject",
};

const getColumns = (editRow,onDelete) => {
  return [
    {
      Header: "Record CreatedBy",
      accessor: "recordCreatedBy",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
      validation: formControl.string().ipv4().required("Required"),
    },
    {
      Header: "Executed by IP",
      accessor: "commandExecutedByClientIP",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "CLI Command",
      accessor: "clicommand",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
    },
    {
      Header: "Record Created On",
      accessor: "recordCreatedOn",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "date",
      //sortDisable: true,
      //allowReportColumn: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Status",
      accessor: "executed",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
    },

    {
      Header: "Approve/ Reject",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <Box display="flex" alignItems="center" gap={1}>
          <RowAction
            row={row}
            value={value}
            onDelete={onDelete}
            onApproved={editRow}
            dynamicName={"Reject Command"}
            description="Reject"
          />
        </Box>
      ),
    },
  ];
};

export { getColumns, Attributes, operationURLS };
